const Shimmer = () => {
  return (
    <div className="mt-28 flex flex-wrap justify-center shimmer-container  flex-row">
      <div
        role="status"
        className="max-w-sm p-1  rounded  animate-pulse md:p-6 "
      >
        <div className="h-[16rem] mb-4 w-[21rem] bg-gray-300 rounded-xl dark:bg-gray-300"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-[14rem] mb-4 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <span className="sr-only">Loading...</span>
      </div>
      <div
        role="status"
        className="max-w-sm p-1  rounded  animate-pulse md:p-6 "
      >
        <div className="h-[16rem] mb-4 w-[21rem] bg-gray-300 rounded-xl dark:bg-gray-300"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-[14rem] mb-4 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <span className="sr-only">Loading...</span>
      </div>
      <div
        role="status"
        className="max-w-sm p-1  rounded  animate-pulse md:p-6 "
      >
        <div className="h-[16rem] mb-4 w-[21rem] bg-gray-300 rounded-xl dark:bg-gray-300"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-[14rem] mb-4 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <span className="sr-only">Loading...</span>
      </div>
      <div
        role="status"
        className="max-w-sm p-1  rounded  animate-pulse md:p-6 "
      >
        <div className="h-[16rem] mb-4 w-[21rem] bg-gray-300 rounded-xl dark:bg-gray-300"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-[14rem] mb-4 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <span className="sr-only">Loading...</span>
      </div>
      <div
        role="status"
        className="max-w-sm p-1  rounded  animate-pulse md:p-6 "
      >
        <div className="h-[16rem] mb-4 w-[21rem] bg-gray-300 rounded-xl dark:bg-gray-300"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-[14rem] mb-4 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <span className="sr-only">Loading...</span>
      </div>
      <div
        role="status"
        className="max-w-sm p-1  rounded  animate-pulse md:p-6 "
      >
        <div className="h-[16rem] mb-4 w-[21rem] bg-gray-300 rounded-xl dark:bg-gray-300"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-[14rem] mb-4 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <span className="sr-only">Loading...</span>
      </div>
      <div
        role="status"
        className="max-w-sm p-1  rounded  animate-pulse md:p-6 "
      >
        <div className="h-[16rem] mb-4 w-[21rem] bg-gray-300 rounded-xl dark:bg-gray-300"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-[14rem] mb-4 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <span className="sr-only">Loading...</span>
      </div>
      <div
        role="status"
        className="max-w-sm p-1  rounded  animate-pulse md:p-6 "
      >
        <div className="h-[16rem] mb-4 w-[21rem] bg-gray-300 rounded-xl dark:bg-gray-300"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-[14rem] mb-4 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <span className="sr-only">Loading...</span>
      </div>
      <div
        role="status"
        className="max-w-sm p-1  rounded  animate-pulse md:p-6 "
      >
        <div className="h-[16rem] mb-4 w-[21rem] bg-gray-300 rounded-xl dark:bg-gray-300"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-[14rem] mb-4 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-[11rem] mb-2.5 ml-1"></div>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Shimmer;
